import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="68" height="55" xmlns="http://www.w3.org/2000/svg" {...props}><text stroke="currentColor" strokeWidth="2" fill="#000" fillRule="evenodd" fillOpacity="0" fontFamily="EuclidCircularA-Medium, Euclid Circular A" fontSize="165" fontWeight="400" letterSpacing="-5.524"><tspan x="-5" y="119">“</tspan></text></svg>);